export const recaptchaSiteKey = process.env.VUE_APP_GOOGLE_RECAPTCHA_SITEKEY
